import { useDispatch, useSelector } from 'react-redux';
import { toastActions } from 'redux/toasts';
import { Store } from 'redux/store';
import { ToastContent } from 'models/toasts';

export const useToast = () => {
  const { toasts } = useSelector((store: Store) => store.toasts);

  const dispatch = useDispatch();

  // 単品でエラー表示する場合
  const appendToast = (toastContent: ToastContent) => {
    dispatch(toastActions.appendToasts([toastContent]));
  };

  // 複数でエラー表示する場合
  const appendToasts = (toastContents: ToastContent[]) => {
    dispatch(toastActions.appendToasts(toastContents));
  };

  // すべてのトーストを削除
  const clearToasts = () => {
    dispatch(toastActions.clearToasts());
  };

  return {
    toasts,
    appendToast,
    appendToasts,
    clearToasts,
  };
};
